import { Buffer } from 'buffer';

// Must be imported before anything else. ESM evaluates imports before the
// body of main.tsx, and TON address derivation calls Buffer while its module
// is loading. Assigning Buffer later leaves the first frame blank.
if (!globalThis.Buffer) globalThis.Buffer = Buffer;
